module.exports = __webpack_public_path__ + "static/media/learnTabSelected.760a77e2.png";